import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            width: 100%;
            [data-test-selector^="productDescriptionLink"] {
                span {
                    font-size: 16px;
                    font-weight: 600;
                    color: #353432;
                }
            }
            div[data-test-selector="productListProductImage"] {
                height: 250px;
            }
            [data-test-selector^="productImage"] {
                max-width: 150px;
                max-height: 150px;
                margin: auto;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    object-position: center top;
                }
            }
            [data-test-selector^="productPriceSavingsMessage"] {
                color: rgb(27, 51, 88);
                font-size: 14px;
                font-weight: bold;
            }
            [data-test-selector="productPrice_unitNetPrice"] {
                color: #3666b1;
                font-size: 18px;
                font-weight: bold;
            }
            [data-test-selector="productPrice_unitOfMeasureLabel"] {
                display: none;
            }
            [data-test-selector="brandLink"] {
                span {
                    font-size: 14px;
                }
            }
            [data-test-selector^="actionsAddToList"] {
                span {
                    color: #353432;
                }
            }
            span[class="add"] {
                background: rgb(54, 102, 177);
                padding: 0px 5px;
                border-radius: 50%;
                margin-right: 10px;
                line-height: 0;
                font-size: 12px;
                color: rgb(255, 255, 255) !important;
            }
            [color^="success"] {
                background: transparent;
                padding: 0;
                div[class^="GridItemStyle"] {
                    padding: 15px;
                }
                span[class^="IconWrapper"] {
                    background: #008061;
                    border-radius: 50%;
                    padding: 2px;
                    height: 16px;
                    width: 16px;
                    svg {
                        height: 12px;
                        width: 12px;
                        color: #fff;
                    }
                }
                [data-test-selector^="availabilityMessage"] {
                    font-size: 14px;
                    margin-top: -5px;
                }
            }
            [color^="danger"] {
                background: transparent;
                padding: 0;
                div[class^="GridItemStyle"] {
                    padding: 15px;
                }
                span[class^="IconWrapper"] {
                    background: #008061;
                    border-radius: 50%;
                    padding: 2px;
                    height: 16px;
                    width: 16px;
                    svg {
                        height: 12px;
                        width: 12px;
                        color: #fff;
                    }
                }
                [data-test-selector^="availabilityMessage"] {
                    font-size: 14px;
                    margin-top: -5px;
                }
            }

            [data-test-selector^="actionsAddToCart"] {
                text-transform: uppercase;
                background-color: #3b7e63;
                color: #ffffff;
                border: 1px solid #3b7e63;
                height: 36px;
                width: 100%;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 100%;
                            `,
                            css`
                                width: 100%;
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    );
                }}
                &:hover {
                    background-color: #3b7e63;
                    color: #fff;
                    border: 1px solid #3b7e63;
                }
                span {
                    font-size: 14px;
                }
            }
            [data-test-selector="availabilityByWarehouseLink"] {
                span {
                    font-size: 14px;
                    color: #000;
                }
            }

            [data-test-selector^="quantityBreakPricingLink"] {
                span {
                    font-size: 14px;
                    color: #000;
                }
            }

            .icon {
                border: 2px solid #008061;
                border-radius: 50%;
                padding: 0px 5px;
                margin-right: 5px;
                font-size: 8px !important;
                color: #008061 !important;
                font-weight: 900;
            }
        `,
    },
};

listStyles.centeringWrapper = {
    css: css`
        width: 100%;
        height: 200px;
        display: flex;
        align-items: center;
        padding: 0 50px;
    `,
};

listStyles.wrapper = {
    css: css`
        margin-top: 20px;
        border-top: 1px solid ${getColor("common.border")};
        > div:last-child {
            > div:first-child[class^="FormFieldStyle"] {
                width: 48%;
                margin-right: 10px;
            }
            > div[class^="FormFieldStyle"] {
                &:nth-child(2) {
                    width: 48%;
                }
            }
            > div[class^="FormFieldStyle"] {
                &:nth-child(3) {
                    width: 48%;
                    margin-right: 10px;
                    margin-top: 10px;
                }
            }
            > div[class^="FormFieldStyle"] {
                &:nth-child(4) {
                    width: 48%;
                    margin-top: 10px;
                }
            }
            > div[class^="FormFieldStyle"] {
                &:nth-child(5) {
                    width: 48%;
                    margin-top: 10px;
                    > div[class^="FormInputWrapper"] {
                        > textarea[data-test-selector^="comments"] {
                            resize: none;
                        }
                    }
                }
            }
            > div {
                > button[data-test-selector^="submitNoProductFoundForm"] {
                    margin: 10px 0;
                }
            }
        }
    `,
};
